import Batch from './src/main'

Batch.install = function (Vue) {
    Vue.component(Batch.name, Batch)
}

export default Batch